<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-content>
          <b-container fluid>
            <palata-form :palatas="palata" :errors="errors"></palata-form>
            <md-card-content>
              <div class="tugmalarb">
                <div>
                  <b-button
                    @click="updatePalata()"
                    class="mr-2 calendar"
                    variant="success"
                  >
                    <b-icon icon="calendar2-plus"></b-icon> {{ $t("Сақлаш") }}
                  </b-button>
                  <b-button
                    @click="cancel()"
                    variant="danger"
                    class="calendar1"
                  >
                    <b-icon icon="calendar2-x"></b-icon> {{ $t("Бекор қилиш") }}
                  </b-button>
                </div>
              </div>
            </md-card-content>
          </b-container>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PalataForm from "./Form.vue";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "PalataUpdate",
  components: {
    PalataForm
  },
  data() {
    return {
      palata: {
        id: 0,
        name: "",
        price: 0,
        room_id: null
      },
      errors: null
    };
  },
  validations: {
    palata: {
      name: {
        required,
        minLength: minLength(4)
      },
      price: {
        required
      },
      room_id: {
        required
      }
    }
  },
  methods: {
    updatePalata() {
      let self = this;
      this.$v.$touch();
      if (this.$v.$invalid == false) {
        axios({
          method: "patch",
          url: `/palata/update/` + self.palata.id,
          data: self.palata
        }).then(data => {
          if (data != undefined) {
            self.$router.push("/palata");
          }
        });
      } else {
        self.errors = self.$v.palata;
      }
    },

    getPalata() {
      let self = this;
      axios({
        method: "get",
        url: `/palata/one/` + self.$route.params.id
      }).then(res => {
        self.palata = res.data.data;
      });
    },
    cancel() {
      this.palata = {
        id: 0,
        name: "",
        price: 0,
        room_id: null
      };
    }
  },
  mounted() {
    this.getPalata();
  }
};
</script>
<style>
.tugmalarb {
  display: flex;
  justify-content: right;
  margin-right: 10px;
  margin-bottom: 10px;
}
.calendar {
  box-shadow: 5px 8px 10px rgba(25, 176, 48, 0.5);
}
.calendar1 {
  box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.5);
}
</style>
